import PickupType from "../enums/PickupType";

const PICKUPS: {
  [key in PickupType]: any;
} = {
  [PickupType.GEM]: {
    nameKey: "pickups.gem.name",
    descriptionKey: "pickups.gem.description",
    tipsKey: "pickups.gem.tips",
    frameName: "gem_blue",
    iconName: "gem_blue",
    pickedupAmount: 0,
    rarity: 0,
    unlocksAt: 100000,
    value: 50,
    seen: true,
  },
  [PickupType.COIN]: {
    nameKey: "pickups.coin.name",
    descriptionKey: "pickups.coin.description",
    tipsKey: "pickups.coin.tips",
    frameName: "coin",
    iconName: "coin",
    pickedupAmount: 0,
    rarity: 50,
    unlocksAt: 0,
    value: 1,
    seen: true,
  },
  [PickupType.APPLE]: {
    nameKey: "pickups.apple.name",
    descriptionKey: "pickups.apple.description",
    tipsKey: "pickups.apple.tips",
    frameName: "apple",
    iconName: "apple",
    pickedupAmount: 0,
    rarity: 50,
    unlocksAt: 0,
    value: 30,
  },
  [PickupType.VACUUM]: {
    nameKey: "pickups.vacuum.name",
    descriptionKey: "pickups.vacuum.description",
    tipsKey: "pickups.vacuum.tips",
    frameName: "magnet_pickup",
    iconName: "magnet_pickup",
    pickedupAmount: 0,
    rarity: 15,
    unlocksAt: 12,
    value: 0,
    isRare: true,
  },
  [PickupType.WEAPON]: {
    nameKey: "pickups.weapon.name",
    descriptionKey: "pickups.weapon.description",
    tipsKey: "pickups.weapon.tips",
    frameName: "",
    pickedupAmount: 0,
    rarity: 0,
    unlocksAt: 1e6,
    hidden: true,
    value: 0,
  },
  [PickupType.TREASURE]: {
    nameKey: "pickups.treasure.name",
    descriptionKey: "pickups.treasure.description",
    tipsKey: "pickups.treasure.tips",
    frameName: "treasure_chest",
    iconName: "treasure_chest",
    pickedupAmount: 0,
    rarity: 0,
    unlocksAt: 0,
    value: 0,
    seen: true,
  },
  [PickupType.CAMEL_CHEST]: {
    nameKey: "pickups.camel_chest.name",
    descriptionKey: "pickups.camel_chest.description",
    tipsKey: "pickups.camel_chest.tips",
    frameName: "camel_chest",
    iconName: "camel_chest",
    pickedupAmount: 0,
    rarity: 0,
    unlocksAt: 0,
    value: 0,
    seen: true,
  },
  0: undefined,
};

export default PICKUPS;
